<template>
  <van-list v-model:loading="loading" :finished="finished" :finished-text="$t('message.noMore')" @load="onLoad">
    <van-cell v-for="item in list.map((item) => item.goodsDataList || item).flat()" :key="item.key">
      <slot v-bind="{ goods: item, orderId: item.showDetailId }"></slot>
    </van-cell>
  </van-list>
</template>

<script setup lang="ts" generic="T extends Record<string, any>">
import { v4 } from "uuid";
import { ref } from "vue";

const props = defineProps<{
  getData: (pageNow: number) => Promise<{ listData: any[]; hasMore: boolean }>;
}>();
const list = ref<any[]>([]);
const page = ref(0);
const loading = ref(false);
const finished = ref(false);

const onLoad = async () => {
  page.value++;
  const { listData, hasMore } = await props.getData(page.value);
  const listDataWithKey = listData.map((item) => ({ ...item, key: v4() }));
  list.value.push(...listDataWithKey);
  loading.value = false;
  if (!hasMore) {
    finished.value = true;
  }
};
</script>
